module.exports = __webpack_public_path__ + "img/MTABAPPABI.f0ef0f8d.svg";